import { Moment } from 'moment-timezone';

export type WaitlistState = 'active' | 'expired' | 'converted';

export type WaitlistSource = 'online_booking' | 'staff';

export type WaitlistView = 'latest' | 'oldest' | 'expired';

export type WaitlistServiceKey = 'grooming' | 'daycare' | 'boarding' | 'transportation' | 'walking' | 'training';

export type WaitlistKey = WaitlistServiceKey | 'all';

export const WAITLIST_SERVICE_KEYS: Array<WaitlistServiceKey> = [
    'grooming',
    'daycare',
    'boarding',
    'transportation',
    'walking',
    'training'
];

export const WAITLIST_VIEWS: Array<WaitlistView> = ['latest', 'oldest', 'expired'];

export interface WaitlistAddon {
    id: number;
    addonServiceId: number;
    addonServiceName: string;
    price: number | null;
}

export interface WaitlistService {
    id: number;
    petId: number;
    petName: string;
    petImage: string | null;
    petType: string;
    petBreedName: string;
    petSize: string;
    petHairLength: string;
    petWeight: number | null;
    serviceId: number;
    serviceName: string;
    businessArea: string;
    /** Informative snapshot: total of the line (every date). */
    price: number | null;
    /** "YYYY-MM-DD", one per occurrence (appointment day, daycare day, boarding night); [] = ASAP. */
    dates: Array<string>;
    /** null = No preference */
    preferredStaffId: number | null;
    preferredStaffName: string | null;
    /** The staff offers this service and works at the location (not availability). */
    preferredStaffEligible: boolean;
    addons: Array<WaitlistAddon>;
}

export interface Waitlist {
    id: number;
    uuid: string;
    marketplaceId: number;
    marketplaceName: string;
    customerId: number;
    customerFirstName: string;
    customerLastName: string | null;
    customerEmail: string | null;
    customerPhone: string | null;
    source: WaitlistSource;
    state: WaitlistState;
    /** "HH:MM" 24h, null = Anytime */
    preferredTime: string | null;
    /** "YYYY-MM-DD", null = Ongoing */
    validUntil: string | null;
    notes: string | null;
    bookingId: number | null;
    createdAt: Moment;
    services: Array<WaitlistService>;
}

export interface WaitlistPet {
    id: number;
    name: string;
    image: string | null;
    type: string;
    breedName: string;
    size: string;
    weight: number | null;
    services: Array<WaitlistService>;
}

export interface WaitlistTabCounts {
    all: number;
    counts: Partial<Record<WaitlistServiceKey, number>>;
}

export interface WaitlistCounts extends WaitlistTabCounts {
    expired: WaitlistTabCounts;
}

export interface WaitlistsPagination {
    page: number;
    size: number;
    totalPages: number;
    totalRecords: number;
}

export interface WaitlistsFilter {
    view: WaitlistView;
    key: WaitlistKey;
    search: string;
    marketplaceIds: Array<number>;
}
